/**
 * The Tracking Health section is ON by default — no environment variable is
 * needed to see it.
 *
 * The variable survives only as a kill switch: set
 * `REACT_APP_TRACKING_HEALTH_ENABLED=0` to hide the section (routes, sidebar
 * item and the Onboarding | Health control) and restore the plain
 * "Onboarding Tracking" nav item, without a code change. Any other value —
 * including unset — leaves it on.
 */
export function useTrackingHealthEnabled(): boolean {
  return process.env.REACT_APP_TRACKING_HEALTH_ENABLED !== "0";
}
